module.exports = __webpack_public_path__ + "static/media/media_paper.91e12d3c.png";